import React from "react";
import classNames from "classnames";
import {Tooltip} from "antd";
import {FormattedMessage} from "react-intl";
import {
    DownloadOutlined
} from "@ant-design/icons";

const CsvDownloader = ({exportCVS, downloadLoading, cancelLoading, onCancel, allowCancel, titleDownload = 'download_csv', titleCancelDownload}) => {
    return (
        <button
            type="button"
            className={classNames("csvBtn", {"downloading": downloadLoading})}
            onClick={exportCVS}>
            {
                downloadLoading ?
                    <div className={classNames("cancelArea", {cancel: cancelLoading})} onClick={() => allowCancel ? onCancel() : null}>
                        <Tooltip title={allowCancel ? <FormattedMessage id={"cancel"}/> : undefined} color={"#fff"}>
                            <div className="loading">
                                <div className="loader"/>
                                {
                                    allowCancel ? <div className="icon"/> : ""
                                }
                            </div>
                        </Tooltip>
                        <FormattedMessage id='exporting'/>
                    </div> :
                    <>
                        <span className="downloadIcon">
                            <DownloadOutlined className="underline"/>
                        </span>
                        <FormattedMessage id={titleDownload}/>
                    </>
            }
        </button>
    )
}

export default CsvDownloader